import { render, staticRenderFns } from "./GestionTurnosSemana.vue?vue&type=template&id=75ab16b4&scoped=true"
import script from "./GestionTurnosSemana.vue?vue&type=script&lang=js"
export * from "./GestionTurnosSemana.vue?vue&type=script&lang=js"
import style0 from "./GestionTurnosSemana.vue?vue&type=style&index=0&id=75ab16b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ab16b4",
  null
  
)

export default component.exports